module.exports = __webpack_public_path__ + "img/2e1b5c54191cb91f4abff2187d11b624.jpg";